import Locations from 'modules/Admin/locations/Locations'

function LocationsPage() {
  const columns = [
    { field: 'name', headerName: 'Location' },
    { field: 'timezone', headerName: 'Time Zone', sortable: false }
  ]
  return (
    <div data-testid="adminLocationsPage">
      <Locations tableColumns={columns} />
    </div>
  )
}

export default LocationsPage
